import { useEffect } from "react";

function isTextEntryField(el: EventTarget | null): el is HTMLInputElement | HTMLTextAreaElement {
    if (!(el instanceof HTMLElement)) return false;
    if (el.tagName === "TEXTAREA") return true;
    if (el.tagName !== "INPUT") return false;

    const type = (el as HTMLInputElement).type;
    if (type === "hidden" || type === "checkbox" || type === "radio" || type === "button" || type === "submit" || type === "file") return false;

    return true;
}

function isMobileKeyboardLayout() {
    return window.matchMedia("(max-width: 900px), (pointer: coarse)").matches;
}

export function useMobileKeyboardScroll() {
    useEffect(() => {
        function onFocusIn(e: FocusEvent) {
            if (!isMobileKeyboardLayout() || !isTextEntryField(e.target)) return;
            if (e.target instanceof HTMLInputElement && !e.target.getAttribute("enterkeyhint")) {
                e.target.setAttribute("enterkeyhint", "next");
            }
        }

        function onKeyDown(e: KeyboardEvent) {
            if (e.key !== "Enter") return;
            if (!isMobileKeyboardLayout() || !isTextEntryField(e.target)) return;
            if (e.target instanceof HTMLTextAreaElement) return;
            if (e.target.getAttribute("aria-expanded") === "true") return;

            const fields = Array.from(document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea")).filter((node) => {
                if (!isTextEntryField(node)) return false;
                return !node.disabled;
            });

            const index = fields.indexOf(e.target);
            const next = fields[index + 1];
            if (!next) return;

            e.preventDefault();
            next.focus();
        }

        document.addEventListener("focusin", onFocusIn);
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("focusin", onFocusIn);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, []);
}
